<template>
  <div>
    <pulse-loader
      :loading="loading"
      :color="color"
      :size="size"
      class="vue-loader"
    ></pulse-loader>
    <div class="row">
      <div class="col-lg-12">
        <div class="box">
          <div class="box-header">
            <h4 class="box-title">
              <i class="icofont-chart-bar-graph"></i> Série histórica
            </h4>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-lg-12">
                <apexchart
                  type="line"
                  height="350"
                  :options="chartOptions"
                  :series="chartData"
                  ref="chartClassificacao"
                ></apexchart>
                <FonteSincronizadorC />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    equipe: {
      type: [Object, String],
      default: '',
    },
    micro_area: {
      type: String,
      default: '',
    },
  },
  components: {
    PulseLoader,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      size: '40px',
      color: '#0D98BB',
      chartData: [],
      chartOptions: {
        chart: {
          height: 300,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
          width: 2,
        },
        title: {
          text: 'Série Histórica',
          align: 'center',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          min: 0,
          max: 3,
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'center',
        },
        markers: {
          size: 5,
        },
        colors: ['#008FFB', '#ff9933', '#025e1b'],
      },
      x_axis: [],
      dataChartMunicipio: [],
      dataChartEquipe: [],
      dataChartMicroArea: [],
    }
  },
  mounted() {},
  watch: {
    equipe: {
      handler(newValue, oldValue) {
        // console.log(newValue)
      },
      deep: true,
    },
    micro_area: {
      handler(newValue, oldValue) {
        // console.log(newValue)
      },
      deep: true,
    },
  },
  computed: {
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  methods: {
    serieHistoricaMunicipio(dadosSerieHistorica, selectedIndicador) {
      if (selectedIndicador.value == 'por-parametro') {
        this.$refs.chartClassificacao.updateSeries([])
        return
      }

      let dataItens = dadosSerieHistorica
      if (selectedIndicador !== null) {
        dataItens = dataItens.filter((item) => {
          return (
            item.ibge === this.$store.state.cod_ibge &&
            item.indicador == selectedIndicador.indicador &&
            item.nivel == 1
          )
        })
      }
      let dataItens12meses = dataItens.slice(Math.max(dataItens.length - 12, 0))
      let array_chart_municipio = []
      let array_xaxis = []
      //carregar eixo x
      for (let i = 0; i < dataItens12meses.length; i++) {
        array_xaxis.push(dataItens12meses[i].mes_ano)
      }
      // carregar dados do município
      for (let i = 0; i < dataItens12meses.length; i++) {
        let dados = JSON.parse(dataItens12meses[i].dados)
        if (selectedIndicador.value == 'por-cadastro-esus') {
          array_chart_municipio.push(dados.escore_pec)
        }
      }
      this.$refs.chartClassificacao.updateOptions({
        xaxis: {
          categories: array_xaxis,
        },
        title: {
          text: 'Gráfico escore - ' + selectedIndicador.label,
        },
      })
      this.xaxis = array_xaxis

      this.$refs.chartClassificacao.updateSeries([
        {
          name: this.$store.state.cidade,
          data: array_chart_municipio,
        },
      ])
      this.dataChartMunicipio = array_chart_municipio
    },

    serieHistoricaEquipe(dadosSerieHistorica, selectedIndicador, equipe) {
      if (equipe == null || equipe == '') {
        if (selectedIndicador.value == 'por-parametro') {
          this.$refs.chartClassificacao.updateSeries([])
          return
        }

        this.$refs.chartClassificacao.updateSeries([
          {
            name: this.$store.state.cidade,
            data: this.dataChartMunicipio,
          },
        ])
        return
      }

      let array_chart_equipe = []
      for (let i = 0; i < this.xaxis.length; i++) {
        var eixo_x_atual = this.xaxis[i]
        let dataItens = dadosSerieHistorica
        if (selectedIndicador !== null) {
          dataItens = dataItens.filter((item) => {
            return (
              item.indicador == selectedIndicador.indicador &&
              item.ine == equipe.nu_ine &&
              item.nivel == 2
            )
          })
        }
        let dataItens12meses = dataItens.slice(
          Math.max(dataItens.length - 12, 0)
        )
        for (const item of dataItens12meses) {
          let dados = JSON.parse(item.dados)
          var escore = 0
          if (selectedIndicador.value == 'por-cadastro-esus') {
            escore = dados.escore_pec
          }
          if (selectedIndicador.value == 'por-parametro') {
            escore = dados.escore_param
          }
          if (item.mes_ano == eixo_x_atual) {
            escore = escore
            break
          } else {
            escore = null
          }
        }
        array_chart_equipe.push(escore)
      }
      this.dataChartEquipe = array_chart_equipe
      this.$refs.chartClassificacao.updateOptions({
        title: {
          text: 'Gráfico escore - ' + selectedIndicador.label,
        },
      })
      if (selectedIndicador.value == 'por-parametro') {
        this.$refs.chartClassificacao.updateSeries([
          {
            name: equipe.no_equipe,
            data: array_chart_equipe,
          },
        ])
        return
      }
      this.$refs.chartClassificacao.updateSeries([
        {
          name: this.$store.state.cidade,
          data: this.dataChartMunicipio,
        },
        {
          name: equipe.no_equipe,
          data: array_chart_equipe,
        },
      ])
    },

    serieHistoricaMicroArea(
      dadosSerieHistorica,
      selectedIndicador,
      equipe,
      micro_area
    ) {
      if (micro_area == null || micro_area == '') {
        if (selectedIndicador.value == 'por-parametro') {
          this.$refs.chartClassificacao.updateSeries([
            {
              name: equipe.no_equipe,
              data: this.dataChartEquipe,
            },
          ])
          return
        }

        this.$refs.chartClassificacao.updateSeries([
          {
            name: this.$store.state.cidade,
            data: this.dataChartMunicipio,
          },
          {
            name: equipe.no_equipe,
            data: this.dataChartEquipe,
          },
        ])
        return
      }

      let array_chart_micro_area = []
      for (let i = 0; i < this.xaxis.length; i++) {
        var eixo_x_atual = this.xaxis[i]
        let dataItens = dadosSerieHistorica
        if (selectedIndicador !== null) {
          dataItens = dataItens.filter((item) => {
            return (
              item.indicador == selectedIndicador.indicador &&
              item.ine == equipe.nu_ine &&
              item.micro_area == micro_area &&
              item.nivel == 3
            )
          })
        }
        let dataItens12meses = dataItens.slice(
          Math.max(dataItens.length - 12, 0)
        )
        for (const item of dataItens12meses) {
          let dados = JSON.parse(item.dados)
          var escore = 0
          if (selectedIndicador.value == 'por-cadastro-esus') {
            escore = dados.escore_pec
          }
          if (selectedIndicador.value == 'por-parametro') {
            escore = dados.escore_param
          }
          if (item.mes_ano == eixo_x_atual) {
            escore = escore
            break
          } else {
            escore = null
          }
        }
        array_chart_micro_area.push(escore)
      }
      this.dataChartMicroArea = array_chart_micro_area
      this.$refs.chartClassificacao.updateOptions({
        title: {
          text: 'Gráfico escore - ' + selectedIndicador.label,
        },
      })
      this.$refs.chartClassificacao.updateSeries([
        {
          name: this.$store.state.cidade,
          data: this.dataChartMunicipio,
        },
        {
          name: equipe.no_equipe,
          data: this.dataChartEquipe,
        },
        {
          name: 'MICROÁREA ' + micro_area,
          data: array_chart_micro_area,
        },
      ])
    },
  },
}
</script>

<style></style>
